/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Logo_ClearInputs */

const cs_settings_office_logo_clear = /** @type {(inputs: Settings_Office_Logo_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odstranit logo`)
};

const en_settings_office_logo_clear = /** @type {(inputs: Settings_Office_Logo_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove logo`)
};

/**
* | output |
* | --- |
* | "Remove logo" |
*
* @param {Settings_Office_Logo_ClearInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_logo_clear = /** @type {((inputs?: Settings_Office_Logo_ClearInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Logo_ClearInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_logo_clear(inputs)
	return cs_settings_office_logo_clear(inputs)
});